import {
  anEntityInterface,
  anEntityPage,
  aSuppressList,
  EntityReputationSource,
  mockEntityListQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockEntity = {
  entityType: 'domain',
  entityTypeName: 'Domain',
  activityScore: 85,
  recentSignalSeverity: 3,
  criticality: 'Low',
  isWhitelisted: false,
  reputation: 'malicious',
  reputationSources: [EntityReputationSource.ThreatIntelligence],
  sensorZone: 'corporate',
  tags: [],
  lastSeen: '2024-01-15T10:30:00Z',
  suppressListsObj: [aSuppressList({ id: 'list-1', name: 'Blocked Domains' })],
};

export const mockEntityListQueryOperationResponse = {
  __typename: 'Query',
  entities: anEntityPage({
    hasNextPage: false,
    total: 3,
    objects: [
      anEntityInterface({
        id: '1',
        value: 'entity1',
        ...mockEntity,
      }),
      anEntityInterface({
        id: '2',
        value: 'entity2',
        ...mockEntity,
      }),
      anEntityInterface({
        id: '3',
        value: 'entity3',
        ...mockEntity,
      }),
    ],
  }),
};

export const handlers = [
  mockEntityListQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entities: anEntityPage(),
        },
      });
    }
  ),
];
